import { jsonApiClient } from '@/httpConfig/config/axios';

// JSON:API type: club-poolshare-totals
// Response data: { totalActiveCents: number, memberCount: number }
// Sanctum-authenticated, NOT membership-gated — every authenticated user can call this.
export const clubPoolShareTotalService = {
  get: (config) => jsonApiClient.get('/clubs/poolshare-total', config),
};
